import { useEffect, useState } from "react";
import { Backpack, Check } from "lucide-react";
import { api } from "@/lib/api";

export const PackingChecklist = () => {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/kit/checklist").then((r) => setC(r.data ?? null)).catch(() => setC(null)); }, []);
  const items = Array.isArray(c?.items) ? c.items : [];
  if (!items.length) return null;
  const toggle = async (it) => { try { const { data } = await api.put("/kit/checklist", { item: it.item, done: !it.done }); setC(data); } catch { /* ignore */ } };
  const ready = items.every((i) => i.done);
  return (
    <section data-testid="packing-checklist" className={`card p-5 sm:p-6 ${ready ? "!border-emerald-400/50" : ""}`}>
      <p className="eyebrow flex items-center gap-2"><Backpack className="w-4 h-4" />Pack for {c.day}</p>
      <h2 className="mt-1 font-display text-3xl text-white">{ready ? "Bag's ready" : `${items.filter((i) => !i.done).length} thing${items.filter((i) => !i.done).length === 1 ? "" : "s"} to pack`}</h2>
      <ul className="mt-4 grid gap-2 sm:grid-cols-2">
        {items.map((it, i) => (
          <li key={it.item}>
            <button data-testid={`pack-item-toggle-${i}`} onClick={() => toggle(it)} className={`w-full flex items-center gap-3 rounded-2xl border px-3.5 py-3 text-left transition-colors ${it.done ? "border-gold-400/50 bg-gold-400/10" : "border-slate-200 bg-surface-2 hover:border-gold-400/50"}`}>
              <span className={`grid place-items-center w-6 h-6 shrink-0 rounded-md border ${it.done ? "bg-gold-400 border-gold-400 text-black" : "border-slate-300"}`}>{it.done && <Check className="w-4 h-4" />}</span>
              <span className="min-w-0"><span className={`block font-semibold ${it.done ? "text-slate-500 line-through" : "text-white"}`}>{it.item}</span><span className="block text-xs text-slate-500 truncate">for {(it.for ?? []).join(", ")}</span></span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};
